import { Command } from "cmdk";
import { useNavigate } from "react-router-dom";

const DESTINATIONS = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/users", label: "Users" },
  { to: "/sessions", label: "Sessions" },
  { to: "/devices", label: "Devices" },
  { to: "/nas", label: "NAS / APs" },
  { to: "/reports", label: "Reports" },
  { to: "/logs", label: "Logs" },
  { to: "/settings", label: "Settings" },
  { to: "/grafana", label: "Grafana" },
  { to: "/audit", label: "Audit log" },
];

export function CommandPalette({ open, onClose }: { open: boolean; onClose: () => void }) {
  const navigate = useNavigate();

  return (
    <Command.Dialog
      open={open}
      onOpenChange={(next) => !next && onClose()}
      label="Command palette"
      className="fixed left-1/2 top-24 z-50 w-full max-w-lg -translate-x-1/2 rounded-lg border border-border bg-surface p-2 shadow-2xl"
    >
      <Command.Input
        placeholder="Jump to a module… (full entity search lands with the Search endpoint)"
        className="w-full rounded-md bg-surface-2 px-3 py-2 text-sm text-text outline-none"
      />
      <Command.List className="mt-2 max-h-80 overflow-y-auto">
        <Command.Empty className="px-3 py-4 text-sm text-text-muted">No matches.</Command.Empty>
        {DESTINATIONS.map((dest) => (
          <Command.Item
            key={dest.to}
            onSelect={() => {
              navigate(dest.to);
              onClose();
            }}
            className="cursor-pointer rounded-md px-3 py-2 text-sm text-text data-[selected=true]:bg-surface-2"
          >
            {dest.label}
          </Command.Item>
        ))}
      </Command.List>
    </Command.Dialog>
  );
}
